import PushEvent from './PushEvent';
import React from 'react';
import EventOrNewsList from '../shared/EventOrNewsList';
import PropTypes from 'prop-types';
import * as resultsStyles from '../../styles/actualites/news-guide.module.scss';

const Results = React.memo(function Results ({events, locale, display}) {
  return (
    <div
      className={resultsStyles.resultContainer}
    >
      {events?.map((event) => {
        const {start_date, title, heading, live, slug, evt_language, cover, end_date, campus, objectID} = event;
        return (display === 'DATE' ?
          <PushEvent
            date={start_date}
            eventLanguage={evt_language}
            href={slug}
            live={live}
            locale={locale}
            objectID={`${objectID}-${slug}-${title}-${live}`}
            preview={heading}
            title={title}
          /> :
          <EventOrNewsList
            campus={campus}
            cover={cover}
            date={start_date}
            end_date={end_date}
            href={slug}
            isEvent
            live={live}
            locale={locale}
            objectID={`${objectID}-${slug}-${title}-${live}`}
            preview={heading}
            title={title}
          />
        );
      })}
    </div>
  );
});

Results.propTypes = {
  display: PropTypes.oneOf(['DATE', 'IMAGE']).isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      start_date: PropTypes.string,
      title: PropTypes.string,
      heading: PropTypes.string,
      live: PropTypes.bool,
      slug: PropTypes.string,
      evt_language: PropTypes.string,
      cover: PropTypes.object,
      end_date: PropTypes.string,
      campus: PropTypes.string,
    })
  ),
  locale: PropTypes.string.isRequired,
};

export default Results;
